module.exports = __webpack_public_path__ + "img/toMy.8ce3e7f1.png";